
import React from 'react';
import styled from 'styled-components';
import tippy from 'tippy.js'; //this '.js' is not a file extension, it's part of the remo name
import 'tippy.js/dist/tippy.css';

import type { EmptyStyledComponent } from '../../types/styledComponent';

const IconWrapper: EmptyStyledComponent = styled.div`
  margin-top: 34px;
  margin-left: 5px;
`;

type TooltipProps = {
  id: string,
  tipText: string,
  className?: string,
};

const Tooltip = ({ id, tipText, className }: TooltipProps) => {
  tippy(`#${id}`, {
    content: tipText,
  });
  const strokeColor = '#efefef';
  return (
    <>
      <IconWrapper>
        {/* this svg pulled and modified from an open license image from https://www.veryicon.com/ */}
        <svg
          id={id}
          xmlns="http://www.w3.org/2000/svg"
          className={className}
          version="1.1"
          viewBox="0 0 1024 1024"
          height="25px"
          width="25px"
        >
          <g fill={strokeColor}>
            <path d="M512 0C229.257143 0 0 229.257143 0 512s229.257143 512 512 512 512-229.257143 512-512S794.742857 0 512 0z m0 937.142857c-234.742857 0-425.142857-190.4-425.142857-425.142857s190.4-425.142857 425.142857-425.142857 425.142857 190.4 425.142857 425.142857-190.4 425.142857-425.142857 425.142857z" />
            <path d="M457.142857 310.857143a54.857143 54.857143 0 1 0 109.714286 0 54.857143 54.857143 0 1 0-109.714286 0z m82.285714 128h-54.857142c-5.028571 0-9.142857 4.114286-9.142858 9.142857v310.857143c0 5.028571 4.114286 9.142857 9.142858 9.142857h54.857142c5.028571 0 9.142857-4.114286 9.142858-9.142857V448c0-5.028571-4.114286-9.142857-9.142858-9.142857z" />
          </g>
        </svg>
      </IconWrapper>
    </>
  );
};

export default Tooltip;
